import {
  migrateSaveScores,
  SCORE_CALIBRATION_VERSION,
} from "./scoring.js";

const GAME_SAVE_KEY = "orbitrush_save_v2";
const MIGRATION_KEY = "orbitrush_score_calibration_v1";
const FORCE_CLOUD_PUSH_KEY = "orbitrush_force_cloud_push_v1";

export function migrateScoreCalibration() {
  try {
    const completedVersion = Number(localStorage.getItem(MIGRATION_KEY) || 0);
    if (completedVersion >= SCORE_CALIBRATION_VERSION) return false;

    const raw = localStorage.getItem(GAME_SAVE_KEY);
    if (raw) {
      const result = migrateSaveScores(JSON.parse(raw));
      if (result.changed) {
        localStorage.setItem(GAME_SAVE_KEY, JSON.stringify(result.save));
        localStorage.setItem(FORCE_CLOUD_PUSH_KEY, "1");
      }
    }
    localStorage.setItem(MIGRATION_KEY, String(SCORE_CALIBRATION_VERSION));
    return true;
  } catch {
    return false;
  }
}
